export const getButtonOptions = (activeButtonIndex, currentIndex) => {
	if (activeButtonIndex === currentIndex) {
		return { color: 'green', key: 'F2' }
	} else {
		return { color: 'gray', key: 'Esc' }
	}
}